module.exports = __webpack_public_path__ + "img/Main_Black.668834b3.svg";